import NotificationLink from './NotificationLink';
import NotificationDate from './NotificationDate';

/**
 * Component to display common content for a notification.
 *
 * @param {string} project_uuid - The UUID of the project.
 * @param {string} project_title - The title of the project.
 * @param {string} model_uuid - The UUID of the model.
 * @param {string} updated_at - The date when the notification was updated.
 * @returns {JSX.Element} The common content including the notification date and project link.
 */
const NotificationContent = ({
	project_uuid,
	project_title,
	project_mode,
	model_uuid,
	model_info,
	updated_at,
	jobType,
	disabled,
}) => {
	return (
		<>
			<NotificationDate date={updated_at} />

			<NotificationLink
				project_uuid={project_uuid}
				project_title={project_title}
				project_mode={project_mode}
				model_uuid={model_uuid}
				model_info={model_info}
				jobType={jobType}
				disabled={disabled}
			/>
		</>
	);
};

export default NotificationContent;
